import { z } from 'zod';

const envSchema = z.object({
  VITE_FIREBASE_API_KEY: z.string().min(1, 'VITE_FIREBASE_API_KEY is required'),
  VITE_FIREBASE_AUTH_DOMAIN: z.string().min(1, 'VITE_FIREBASE_AUTH_DOMAIN is required'),
  VITE_FIREBASE_PROJECT_ID: z.string().min(1, 'VITE_FIREBASE_PROJECT_ID is required'),
  VITE_API_URL: z.string().url('VITE_API_URL must be a valid URL').default('http://localhost:8080'),
  VITE_SENTRY_DSN: z.string().optional(),
  VITE_APP_URL: z.string().url().optional().default('http://localhost:5174'),
  VITE_CLIENT_APP_URL: z.string().url().optional().default('http://localhost:5173'),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  console.error('Invalid environment variables:', parsed.error.flatten().fieldErrors);
  throw new Error('Invalid environment variables. Check .env.local');
}

export const env = parsed.data;
